import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { UI_DATETIME_FMT } from "@iscr/helpers/datetime";
export function DateTime({ value, format = UI_DATETIME_FMT }) {
    if (!value) {
        return null;
    }
    const v = moment(value);
    return _jsx("time", { dateTime: v.toISOString(), children: v.format(format) });
}
